import { NetworkService } from './network-service';
import { jwtDecode } from 'jwt-decode';

// store
import { storeGet } from '../store';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class AuthenticationService {

    static wasLoggedIn = () => {
        const token = storeGet('getToken');
        return token ?? false;
    };

    static isExpired = () => {
        const token = storeGet('getToken');

        if (!token) {
            return false;
        }

        let decoded = jwtDecode(token);

        if (!decoded) {
            return false;
        }

        let currentTs = new Date().getTime();

        if (currentTs >= (decoded.exp * 1000)) {
            return true; //FIXME: try refresh
        }

        return false;
    };

    static isLoggedIn = () => {
        const token = storeGet('getToken');

        if (!token) {
            return false;
        }

        let decoded = jwtDecode(token);

        if (!decoded) {
            return false;
        }

        let currentTs = new Date().getTime();

        if (currentTs >= decoded.exp * 1000) {
            return false; //FIXME: try refresh
        }

        return true;
    };

    /**
     * Get current user data
     * @returns {Promise<Object>} User data
     */
    static async meAsync() {
        return await NetworkService.getAsync(`${API_BASE_URL}/user/me`);
    }

    /**
     * Login user
     * @param {Object} credentials - { email, password }
     * @returns {Promise<Object>} { access_token }
     */
    static async loginAsync(credentials) {
        return await NetworkService.unauthorizedPostAsync(`${API_BASE_URL}/user/login`, credentials);
    }

    /**
     * Register new user
     * @param {Object} data - Registration data
     * @param {Array} queryParams - Query parameters array
     * @returns {Promise<Object>} Registration response
     */
    static async registerUserAsync(data, queryParams) {
        return await NetworkService.unauthorizedPostAsync(`${API_BASE_URL}/user/register`, data, queryParams);
    }

    /**
     * Request password reset
     * @param {Object} body - { email }
     * @returns {Promise<Object>} Response
     */
    static async forgotPasswordAsync(body) {
        return await NetworkService.unauthorizedPutAsync(`${API_BASE_URL}/user/change-password/request`, body);
    }

    /**
     * Reset password with token
     * @param {Object} body - { token, password }
     * @returns {Promise<Object>} Response
     */
    static async resetPasswordAsync(body) {
        return await NetworkService.unauthorizedPostAsync(`${API_BASE_URL}/user/change-password/set`, body);
    }

    /**
     * Change password while logged in
     */
    static async changePasswordAsync(body) {
        return await NetworkService.postAsync(`${API_BASE_URL}/user/change-password`, body);
    }

    /**
     * Delete current account
     */
    static async deleteAccountAsync() {
        return await NetworkService.deleteAsync(`${API_BASE_URL}/user/me`);
    }

    // Legacy callback-based methods - DEPRECATED, use async methods above

    static login = (loginRequest, callback, errCallback) => {
        NetworkService.unauthorizedPost(`${API_BASE_URL}/user/login`, loginRequest, callback, errCallback);
    };

    static registerUser = (registerRequest, callback, errCallback, queryParams) => {
        NetworkService.unauthorizedPost(`${API_BASE_URL}/user/register`, registerRequest, callback, errCallback, queryParams);
    };

    static forgotPassword = (body, callback, errCallback) => {
        NetworkService.unauthorizedPut(`${API_BASE_URL}/user/change-password/request`, body, callback, errCallback);
    }

    static resetPassword = (body, callback, errCallback) => {
        NetworkService.unauthorizedPost(`${API_BASE_URL}/user/change-password/set`, body, callback, errCallback);
    }

    static me = (callback, errCallback) => {
        NetworkService.get(`${API_BASE_URL}/user/me`, callback, errCallback);
    };
}
